import React from 'react'
import Image from 'next/image'
import Link from 'next/link'

import styled from '@emotion/styled'
import { useTranslation } from 'next-i18next'
import { Cookies } from 'react-cookie'

import { BLUR, HOST, TAIL } from 'constants/image'
import Bookmark from 'components/common/Bookmark'
import KTCPromotions from 'components/ktc/KTCPromotions'

const IMAGE_HEIGHT = 140

const ProductCard = ({
  id,
  store_id,
  label,
  image,
  name,
  price,
  currency,
  promotions_2,
  catgory = 'appointment',
}) => {
  const cookies = new Cookies()
  const subdomain = cookies.get('subdomain')

  const { t } = useTranslation()

  const calculateLink = () => {
    return subdomain === 'reserve' && parseInt(price) === 0
      ? 'appointment'
      : 'food'
  }

  return (
    <Container>
      {/* <Link href={`/${calculateLink()}/${store_id}/product/${id}`}> */}
      <Link href={`/${catgory}/${store_id}/product/${id}`}>
        <MenuContainer>
          <div className="display-flex-direction">
            <div>
              <h3 className="title clamp2">{name}</h3>
              {label &&
                label.split(',').map((item) => (
                  <span key={item} className="label">
                    #{item}{' '}
                  </span>
                ))}
            </div>
            <div>
              <div className="display-flex-end" style={{ marginBottom: 8 }}>
                <p className="sale-price">{t('ktc:sale_price')}</p>
                <p className="price">
                  {parseInt(price).toLocaleString('ko-kr')}
                </p>
                <p className="currency">{currency}</p>
              </div>

              <KTCPromotions promotions_2={promotions_2} />
            </div>
          </div>

          <div style={{ position: 'relative' }}>
            <Image
              src={image ? `${HOST}${image}${TAIL}` : BLUR}
              alt=""
              width={IMAGE_HEIGHT}
              height={IMAGE_HEIGHT}
              style={{
                borderRadius: 10,
                objectFit: 'cover',
              }}
            />
            <Bookmark
              store_id={store_id}
              product_id={id}
              absolute
              isKTC
              styles={{ width: 24, height: 24 }}
            />
          </div>
        </MenuContainer>
      </Link>
    </Container>
  )
}

export default ProductCard

const Container = styled.li`
  a {
    display: contents;
  }

  .label {
    font-size: 14px;
    color: #aaa;
  }

  .display-flex {
    display: flex;
    align-items: center;
  }

  .vertical-line {
    padding-left: 4px;
    margin-right: 4px;
  }

  .benefits:last-child .vertical-line {
    display: none;
  }

  .display-flex-direction {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .display-flex-end {
    display: flex;
    align-items: flex-end;
  }

  .title {
    font-weight: 700;
    font-size: 18px;
  }

  .sale-price {
    font-size: 12px;
  }

  .price {
    margin: 0 8px -2px;
    font-size: 20px;
    font-weight: 700;
  }

  .currency {
    font-size: 12px;
    color: #aaa;
  }
`

const MenuContainer = styled.div`
  height: calc(${IMAGE_HEIGHT}px + 16px);
  display: flex;
  justify-content: space-between;
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid #e0e0e0;
`
